import { isLocalhost } from "../url/isLocalhost";

function _isSessionStorageEnabled() {
  try {
    const key = `__storage__test`;
    window.sessionStorage.setItem(key, null);
    window.sessionStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

function _isLocalStorageEnabled() {
  try {
    const key = `__storage__test`;
    window.localStorage.setItem(key, null);
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

const isSessionStorageEnabled = _isSessionStorageEnabled();
const isLocalStorageEnabled = _isLocalStorageEnabled();

export function getStorageArea(
  preferred: "session" | "local" | "memory" = "local"
) {
  if (preferred === "session" && isSessionStorageEnabled) {
    return sessionStorage;
  }

  if (preferred === "local" && isLocalStorageEnabled) {
    return localStorage;
  }

  if (preferred === "memory") {
    return memoryStorage;
  }

  if (isLocalhost && isLocalStorageEnabled) {
    return localStorage;
  }

  if (isSessionStorageEnabled) {
    return sessionStorage;
  }

  if (isLocalStorageEnabled) {
    return localStorage;
  }

  return memoryStorage;
}

const memoryStore = {};
const getItem: Storage["getItem"] = (key) => {
  return memoryStore[key + ""] ?? null;
};

const setItem: Storage["setItem"] = (key, value) => {
  memoryStore[key + ""] = value + "";
};

const removeItem: Storage["removeItem"] = (key) => {
  delete memoryStore[key + ""];
};

const memoryStorage = { getItem, setItem, removeItem };
